<template>

  <div class="range-selector">
    <vue-slider ref="slider" class="range-selector__slider"
      :piecewise="false"
      v-model:value="value"
      width="270px"
      :height="6"
      :interval="interval"
      :dotSize="12"
      :min="this.attribute.min"
      :max="this.attribute.max"
      :disabled="false"
      :show="true"
      tooltip="always"
      :tooltipDir="['top','top']"
      :bgStyle="bgStyle"
      :sliderStyle="[sliderStyle, sliderStyle]"
      :tooltipStyle="[tooltipStyle, tooltipStyle]"
      :processStyle="processStyle"
      :labelStyle="labelStyle"
      :formatter="formatString"
      :clickable="false"
    ></vue-slider>

    <div class="range-selector__submit-button" @click="handleClick">
      <svg-icon width="16px" height="16px" :icon="Check"></svg-icon>
    </div>

  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
import SvgIcon from '@/components/common/svgIcon'
import Check from '@/assets/svg/Check.svg'
import { commaFormatString } from '@/helpers'

export default {
  components: {
    vueSlider, SvgIcon
  },
  props: {
    attribute: Object
  },
  data () {
    return {
      value: [
        this.attribute.value ? this.attribute.value.min : this.attribute.min,
        this.attribute.value ? this.attribute.value.max : this.attribute.max
      ],
      Check,
      bgStyle: {
        backgroundColor: '#A0A7AC'
      },
      sliderStyle: {
        backgroundColor: 'black',
        borderColor: 'white',
        borderWidth: '3px',
        borderStyle: 'solid',
        display: 'block',
        position: 'relative'
      },
      tooltipStyle: {
        backgroundColor: 'black',
        borderWidth: '0',
        borderColor: 'black',
        position: 'absolute',
        top: '-8.5px'
      },
      processStyle: {
        backgroundColor: '#FFBD00'
      },
      labelStyle: {
        background: 'green'
      }
    }
  },
  computed: {
    interval () {
      const gap = (this.attribute.max - this.attribute.min) / 100
      if (Math.floor(gap) === gap) {
        return gap
      } else {
        return 1
      }
    }
  },
  methods: {
    refreshSlider () {
      this.$refs.slider.getStaticData()
    },
    handleClick () {
      const newValue = {
        min: this.value[0],
        max: this.value[1]
      }
      this.$emit('select', newValue)
    },
    formatString (val) {
      return commaFormatString(`${val}`)
    }
  }
}
</script>

<style lang="scss">

.range-selector {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: auto;
  padding-top: 12px;

  &__submit-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #A0A7AC;
    color: black;
    font-size: 16px;
    z-index: $z-4;
  }

  &__submit-button:hover {
    background-color: #27A500;
    cursor: pointer;
  }

}

// To get the dot to display in the middle, with a border around the dots, I need to overide some classes in the slider I imported from npm
.align-center-slider {
  vertical-align: middle;
}

.vue-slider-dot {
  position: absolute !important;
  top: -6px !important;
}

.vue-slider-horizontal {
  padding-bottom: 0px !important;
  height: 20px !important;
  margin-top: auto;
}


</style>



// WEBPACK FOOTER //
// RangeSlider.vue?3403bfb5